import React from 'react';
import logoAndes from '../assets/logoAndesBlanco.png';
import DashboardMetricCard from './DashboardMetricCard';

const DashboardSection = ({ metrics = [], fechaInicio, fechaFin, onFechaChange }) => {
  // Filtro de fechas para actualizar el dashboard

  // Utilidades para convertir entre formatos
  const toInputFormat = (fecha) => {
    if (!fecha) return '';
    // de 'YYYY-MM-DD HH:mm' a 'YYYY-MM-DDTHH:mm'
    return fecha.replace(' ', 'T').slice(0, 16);
  };
  const fromInputFormat = (fecha) => {
    // de 'YYYY-MM-DDTHH:mm' a 'YYYY-MM-DD HH:mm'
    return fecha.replace('T', ' ');
  };

  const [inicio, setInicio] = React.useState(toInputFormat(fechaInicio));
  const [fin, setFin] = React.useState(toInputFormat(fechaFin));

  React.useEffect(() => {
    setInicio(toInputFormat(fechaInicio));
    setFin(toInputFormat(fechaFin));
  }, [fechaInicio, fechaFin]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onFechaChange) onFechaChange(fromInputFormat(inicio), fromInputFormat(fin));
  };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-7xl mx-auto mt-8">
      <div className="flex flex-col items-center mb-6">
        <img src={logoAndes} alt="Logo AndesBPO" className="h-16 w-auto mb-2" style={{ maxWidth: 120 }} />
      </div>
      <h1 className="text-4xl font-extrabold text-gray-900 mb-8">Dashboard de TI</h1>
      <form className="flex flex-wrap gap-4 items-center mb-8" onSubmit={handleSubmit}>
        <label className="font-semibold">Desde:
          <input
            type="datetime-local"
            className="ml-2 border rounded px-2 py-1"
            value={inicio}
            onChange={e => setInicio(e.target.value)}
            required
          />
        </label>
        <label className="font-semibold">Hasta:
          <input
            type="datetime-local"
            className="ml-2 border rounded px-2 py-1"
            value={fin}
            onChange={e => setFin(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="bg-custom-blue text-white px-4 py-2 rounded font-bold">Actualizar</button>
      </form>
      {/* Agrupación de métricas por secciones */}
      {metrics && metrics.length > 0 ? (
        <>
          {/* Métricas generales */}
          <h2 className="text-xl font-bold mt-4 mb-2 text-custom-blue">Resumen General</h2>
          <div className="grid gap-6 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', maxWidth: '1100px', margin: '0 auto' }}>
            {metrics.slice(0, 5).map((metrica, idx) => (
              <div key={idx} className={`rounded-2xl shadow-md p-8 flex flex-col items-center ${metrica.color || 'bg-white text-gray-900'}`}>
                <div className="text-2xl mb-2">{metrica.icono || ''}</div>
                <div className="text-lg font-bold mb-2 text-center" style={{ wordBreak: 'break-word' }}>{metrica.nombre || 'Métrica'}</div>
                <div className="text-4xl font-extrabold mb-2">{metrica.valor ?? 0}</div>
              </div>
            ))}
          </div>

          {/* Top responsables */}
          <h2 className="text-xl font-bold mt-4 mb-2 text-purple-700">Top Responsables</h2>
          <div className="grid gap-6 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', maxWidth: '1100px', margin: '0 auto' }}>
            {metrics.slice(5, 8).map((metrica, idx) => (
              <div key={idx} className={`rounded-2xl shadow-md p-8 flex flex-col items-center ${metrica.color || 'bg-white text-gray-900'}`}>
                <div className="text-2xl mb-2">{metrica.icono || ''}</div>
                <div className="text-lg font-bold mb-2 text-center" style={{ wordBreak: 'break-word' }}>{metrica.nombre || 'Métrica'}</div>
                <div className="text-4xl font-extrabold mb-2">{metrica.valor ?? 0}</div>
              </div>
            ))}
          </div>

          {/* Top sedes */}
          <h2 className="text-xl font-bold mt-4 mb-2 text-indigo-700">Top Sedes</h2>
          <div className="grid gap-6 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', maxWidth: '1100px', margin: '0 auto' }}>
            {metrics.slice(8, 11).map((metrica, idx) => (
              <div key={idx} className={`rounded-2xl shadow-md p-8 flex flex-col items-center ${metrica.color || 'bg-white text-gray-900'}`}>
                <div className="text-2xl mb-2">{metrica.icono || ''}</div>
                <div className="text-lg font-bold mb-2 text-center" style={{ wordBreak: 'break-word' }}>{metrica.nombre || 'Métrica'}</div>
                <div className="text-4xl font-extrabold mb-2">{metrica.valor ?? 0}</div>
              </div>
            ))}
          </div>

          {/* Top campañas */}
          <h2 className="text-xl font-bold mt-4 mb-2 text-pink-700">Top Campañas</h2>
          <div className="grid gap-6 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', maxWidth: '1100px', margin: '0 auto' }}>
            {metrics.slice(11, 14).map((metrica, idx) => (
              <div key={idx} className={`rounded-2xl shadow-md p-8 flex flex-col items-center ${metrica.color || 'bg-white text-gray-900'}`}>
                <div className="text-2xl mb-2">{metrica.icono || ''}</div>
                <div className="text-lg font-bold mb-2 text-center" style={{ wordBreak: 'break-word' }}>{metrica.nombre || 'Métrica'}</div>
                <div className="text-4xl font-extrabold mb-2">{metrica.valor ?? 0}</div>
              </div>
            ))}
          </div>

          {/* Top solicitantes */}
          <h2 className="text-xl font-bold mt-4 mb-2 text-teal-700">Top Solicitantes</h2>
          <div className="grid gap-6 mb-8" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', maxWidth: '1100px', margin: '0 auto' }}>
            {metrics.slice(14, 17).map((metrica, idx) => (
              <div key={idx} className={`rounded-2xl shadow-md p-8 flex flex-col items-center ${metrica.color || 'bg-white text-gray-900'}`}>
                <div className="text-2xl mb-2">{metrica.icono || ''}</div>
                <div className="text-lg font-bold mb-2 text-center" style={{ wordBreak: 'break-word' }}>{metrica.nombre || 'Métrica'}</div>
                <div className="text-4xl font-extrabold mb-2">{metrica.valor ?? 0}</div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="text-gray-500">Sin datos</div>
      )}
    </div>
  );
};

export default DashboardSection;